import { Link } from "react-router-dom";
import RoosterLogo from "@/components/RoosterLogo";

/** Shared shell for /login, /signup, /forgot-password, /reset-password.
 *  Brand-consistent yellow-and-black brutalist card on a soft gray field. */
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-[#F9F9F9] flex flex-col">
      <header className="px-6 lg:px-12 py-5">
        <Link to="/?stay=1" className="inline-flex items-center gap-3">
          <RoosterLogo size={36} />
          <div className="font-display text-2xl font-black tracking-tighter">Weathervane</div>
        </Link>
      </header>
      <main className="flex-1 flex items-start justify-center px-4 py-8">
        <div className="w-full max-w-md">
          <div className="border-2 border-black bg-white p-7 sm:p-9 relative">
            <div className="absolute top-0 left-0 right-0 h-2 bg-[#FFD600]" />
            <div className="ticker-label !text-[10px] mb-3 mt-1">{subtitle || "Weathervane"}</div>
            <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tighter mb-7" data-testid="auth-title">
              {title}
            </h1>
            {children}
          </div>
          {footer && <div className="mt-5 text-center text-sm text-neutral-700">{footer}</div>}
        </div>
      </main>
    </div>
  );
}
